/**
 * @desc 表格可编辑的状态下checkbox类型的单元格没有浏览态与编辑态之分, 因此需要在checkbox的属性上去判断此单元格是否可编辑
 */
export function checkboxInTable(dom) {
    if (dom.tagName !== 'INPUT') {return false;}

    //如果是不可编辑的checkbox就继续查找下一个可聚焦元素
    if (dom && dom.disabled === true) {
        return true;
    }

}
